<template>
    <button
        :type="type"
        class="
            inline-flex
            bg-primary
            rounded-full
            text-sm text-white
            px-10
            py-2
            font-medium
            tracking-wide
            focus:outline-none
            hover:bg-white hover:text-primary
            transition-all
            duration-500
        "
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: "submit",
        },
    },
};
</script>
